import { ReactNode, createContext, useContext } from 'react'

interface Props extends ILayoutContext {
  children: ReactNode
}

export interface ILayoutContext {
  onClick?: (keyPath?: string) => void
  selectedKey?: number
}

const LayoutContext = createContext<ILayoutContext>({})

export function LayoutProvider({ children, ...rest }: Props) {
  return <LayoutContext.Provider value={rest}>{children}</LayoutContext.Provider>
}

export function useLayoutContext() {
  return useContext(LayoutContext) || {}
}
